export const isDev = process.env.NODE_ENV === 'development';
export const propsFiles = process.env.REACT_APP_PROPS_FILE || 'props.mock';
